<template>
    <div>
        <section class="row mx-0 subtitle-1 iransans">
            <div class="col-12 d-flex align-center pa-3 border-bottom">
                <v-btn
                        outlined
                        x-small
                        fab
                        color="grey lighten-1"
                        tag="span"
                >
                    <v-icon small>mdi-web</v-icon>
                </v-btn>

                <div class="pr-3 flex-grow-1">
                    آدرس درخواست

                    <CopyToClipboard
                            :text="log.url"
                            class="d-block font-weight-medium ltr "
                            button-class="ml-2"
                    >
                        <v-chip
                                small
                                label
                                outlined
                                class="px-2 mr-2 text-uppercase"
                        >{{ log.request_method }}</v-chip>

                        <router-link
                                :to="{ name: 'Logs', query: { filters: [{ column_name : 'url', value: log.url, operand: 'Contains' }], orders: [{column_name : 'id', value : 'desc'}] } }"
                                class="no-decoration"
                        >{{ log.url }}</router-link>
                    </CopyToClipboard>
                </div>
            </div>

            <div class="col-md-4 d-flex align-center pa-3 border-bottom">
                <v-btn
                        outlined
                        x-small
                        fab
                        color="grey lighten-1"
                        tag="span"
                >
                    <v-icon small>mdi-account</v-icon>
                </v-btn>

                <div class="pr-3">
                    کاربر

                    <router-link
                            v-if="log.user_id"
                            :to="{ name: 'Logs', query: { filters: [{ column_name : 'user_id', value: log.user_id, operand: 'Contains' }], orders: [{column_name : 'id', value : 'desc'}] } }"
                            class="d-block font-weight-medium no-decoration"
                    >
                        {{ users[log.user_id] ? users[log.user_id].full_name : 'نامشخص' }}
                    </router-link>

                    <span
                            v-else
                            class="d-block font-weight-medium grey--text text--darken-3"
                    >تعریف نشده</span>
                </div>
            </div>

            <div class="col-md-4 d-flex align-center pa-3 border-bottom">
                <v-btn
                        outlined
                        x-small
                        fab
                        color="grey lighten-1"
                        tag="span"
                >
                    <v-icon small>mdi-api</v-icon>
                </v-btn>

                <div class="pr-3">
                    سرویس گیرنده

                    <router-link
                            v-if="log.client_id"
                            :to="{ name: 'Logs', query: { filters: [{ column_name : 'client_id', value: log.client_id, operand: 'Contains' }], orders: [{column_name : 'id', value : 'desc'}] } }"
                            class="d-block font-weight-medium no-decoration"
                    >
                        {{ clients[log.client_id] ? clients[log.client_id].name : 'نامشخص' }}
                    </router-link>

                    <span
                            v-else
                            class="d-block font-weight-medium grey--text text--darken-3"
                    >تعریف نشده</span>
                </div>
            </div>

            <div class="col-md-4 d-flex align-center pa-3 border-bottom">
                <v-btn
                        outlined
                        x-small
                        fab
                        color="grey lighten-1"
                        tag="span"
                >
                    <v-icon small>mdi-calendar-check</v-icon>
                </v-btn>

                <div class="pr-3">
                    تاریخ ایجاد

                    <span class="d-block font-weight-medium grey--text text--darken-3">
                        {{ getJalaliDate((log.created_at * 1000), 'HH:mm:ss jYYYY/jMM/jDD') }}
                    </span>
                </div>
            </div>

            <div class="col-md-4 d-flex align-center pa-3 border-bottom">
                <v-btn
                        outlined
                        x-small
                        fab
                        color="grey lighten-1"
                        tag="span"
                >
                    <v-icon small>mdi-calendar-export</v-icon>
                </v-btn>

                <div class="pr-3">
                    تاریخ درخواست

                    <span class="d-block font-weight-medium grey--text text--darken-3">
                        {{ getJalaliDate(log.requested_at_millisecond, 'HH:mm:ss jYYYY/jMM/jDD') }}
                    </span>
                </div>
            </div>

            <div class="col-md-4 d-flex align-center pa-3 border-bottom">
                <v-btn
                        outlined
                        x-small
                        fab
                        color="grey lighten-1"
                        tag="span"
                >
                    <v-icon small>mdi-calendar-import</v-icon>
                </v-btn>

                <div class="pr-3">
                    تاریخ پاسخ

                    <span class="d-block font-weight-medium grey--text text--darken-3">
                        {{ getJalaliDate(log.responded_at_millisecond, 'HH:mm:ss jYYYY/jMM/jDD') }}
                    </span>
                </div>
            </div>

            <div
                    v-for="(key, index) in availableIdentifiers"
                    :key="key"
                    :class="['d-flex align-center pa-3 border-bottom', ((index + 1) === availableIdentifiers.length ? 'col' : 'col-md-4')]"
            >
                <v-btn
                        outlined
                        x-small
                        fab
                        color="grey lighten-1"
                        tag="span"
                >
                    <v-icon small>mdi-identifier</v-icon>
                </v-btn>

                <div class="pr-3">
                    {{ identifiers[key].label }}

                    <router-link
                            :to="{ name: 'Logs', query: { filters: [ { column_name : key, value: log[key], operand: 'IsEqualTo' } ], orders: [{column_name : 'id', value : 'desc'}] } }"
                            class="d-block font-weight-medium no-decoration"
                    >{{ log[key] }}</router-link>
                </div>
            </div>
        </section>

        <!-- Query String -->
        <section class="mt-4">
            <div class="d-flex align-center subtitle-1 font-weight-bold iransans mb-2">
                <span>متغییر های درخواست (url variables)</span>

                <v-spacer></v-spacer>

                <CopyToClipboard
                        v-if="queryString"
                        :text="log.query_string"
                        button-class="d-none"
                        :action-on-button="false"
                >
                    <v-btn
                            color="primary"
                            text
                            small
                    >
                        <v-icon
                                :size="14"
                                class="ml-2"
                        >mdi-content-copy</v-icon>
                        کپی
                    </v-btn>
                </CopyToClipboard>
            </div>

            <v-card
                    color="grey lighten-5"
                    outlined
                    :disabled="!urlVariables"
            >
                <v-card-text class="pa-0">
                    <JSONView
                            v-if="urlVariables"
                            :data="urlVariables"
                            root-key="url_variables"
                            class="ltr"
                    />

                    <div
                            v-else
                            class="text-center py-2"
                    >تعریف نشده</div>
                </v-card-text>
            </v-card>
        </section>

        <!-- Request Body -->
        <section class="mt-4">
            <div class="d-flex align-center subtitle-1 font-weight-bold iransans mb-2">
                <span>درخواست (request)</span>

                <v-spacer></v-spacer>

                <CopyToClipboard
                        v-if="request"
                        :text="JSON.stringify(request)"
                        button-class="d-none"
                        :action-on-button="false"
                >
                    <v-btn
                            color="primary"
                            text
                            small
                    >
                        <v-icon
                                :size="14"
                                class="ml-2"
                        >mdi-content-copy</v-icon>
                        کپی
                    </v-btn>
                </CopyToClipboard>
            </div>

            <v-card
                    color="grey lighten-5"
                    outlined
                    :disabled="!request"
            >
                <v-card-text class="pa-0">
                    <JSONView
                            v-if="request"
                            :data="request"
                            root-key="request"
                            class="ltr"
                    />

                    <div
                            v-else
                            class="text-center py-2"
                    >تعریف نشده</div>
                </v-card-text>
            </v-card>
        </section>

        <!-- Response Body -->
        <section class="mt-4">
            <div class="d-flex align-center subtitle-1 font-weight-bold iransans mb-2">
                <span>پاسخ (response)</span>

                <v-spacer></v-spacer>

                <CopyToClipboard
                        v-if="response"
                        :text="JSON.stringify(response)"
                        button-class="d-none"
                        :action-on-button="false"
                >
                    <v-btn
                            color="primary"
                            text
                            small
                    >
                        <v-icon
                                :size="14"
                                class="ml-2"
                        >mdi-content-copy</v-icon>
                        کپی
                    </v-btn>
                </CopyToClipboard>
            </div>

            <v-card
                    color="grey lighten-5"
                    outlined
                    :disabled="!response"
            >
                <v-card-text class="pa-0">
                    <JSONView
                            v-if="response"
                            :data="response"
                            root-key="response"
                            class="ltr"
                    />

                    <div
                            v-else
                            class="text-center py-2"
                    >تعریف نشده</div>
                </v-card-text>
            </v-card>
        </section>
    </div>
</template>

<script>
    import Qs from 'qs';
    import { JSONView } from 'vue-json-component';

    // Vuex
    import { mapState, mapActions } from 'vuex';
    import InternalApplicationException from "../exceptions/InternalApplicationException";

    export default {
        components: {
            JSONView
        },
        props: {
            log: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                identifiers: {
                    fax_id: {
                        label: 'شناسه فکس ارسالی'
                    },
                    receipt_id: {
                        label: 'شناسه رسید'
                    },
                    subscription_class_id: {
                        label: 'شناسه بسته اشتراکی'
                    }
                }
            }
        },
        created() {
            this.fetchUsers();
            this.fetchClients();
        },
        computed: {
            ...mapState({
                users: state => state.users.users,
                clients: state => state.clients.clients,
            }),

            request() {
                try{
                    let request = JSON.parse(this.log.request);

                    if(
                        (typeof request.body === 'string') &&
                        this.isJson(request.body)
                    ) {
                        request.body = JSON.parse(request.body);
                    }

                    for (const key in request.headers) {
                        let value = request.headers[key];
                        request.headers[key] = value[0];
                    }
                    return request;
                }catch (err){
                    throw new InternalApplicationException(err);
                }


            },
            response() {
                try {
                    let response = JSON.parse(this.log.response);

                    if (
                        (typeof response.body === 'string') &&
                        this.isJson(response.body)
                    ) {
                        response.body = JSON.parse(response.body);
                    }

                    for (const key in response.headers) {
                        let value = response.headers[key];
                        response.headers[key] = value[0];
                    }

                    return response;
                }catch (err){
                    throw new InternalApplicationException(err);
                }
            },
            urlVariables() {
                if(!this.log.query_string) return;

                return Qs.parse(this.log.query_string);
            },

            availableIdentifiers() {
                let availableIdentifiers = [];

                for (const key in this.identifiers) {
                    if(!this.log[key]) continue;

                    availableIdentifiers.push(key);
                }

                return availableIdentifiers;
            }
        },
        methods: {
            ...mapActions('users', ['fetchUsers']),
            ...mapActions('clients', ['fetchClients']),

            isJson(str) {
                try {
                    JSON.parse(str);
                } catch (e) {
                    return false;
                }

                return true;
            }
        }
    }
</script>